import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { setTokens } from '../../providers/axios';
import { HEIGHT_BELOW_ENVIRONMENT_BAR } from '../../components/layout/environmentBarSpace';

export const AuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get('accessToken');
    const refreshToken = params.get('refreshToken');
    const error = params.get('error');

    if (error) {
      console.error('Auth error:', error);
      // Hand the code to the login page, which shows a fixed message for it.
      navigate(`/login?${new URLSearchParams({ error }).toString()}`, { replace: true });
      return;
    }

    if (accessToken && refreshToken) {
      setTokens(accessToken, refreshToken);
      navigate('/', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    // SF-5172: the window less the environment bar above, so the page does not scroll.
    <div
      style={{
        height: HEIGHT_BELOW_ENVIRONMENT_BAR,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin size="large" tip="Signing in..." />
    </div>
  );
};
